export type Release = { version: string; date: string; features: string[]; bugFixes: string[] };

export function parseChangelog(md: string): Release[] {
    /** Parses headings like:
     *  - "## 0.0.1 - 2025 - 07 - 17"
     *  - "## 0.0.1 - 2025-07-17"
     *  - "## [0.0.1](link) - 2025-07-17"
     *  - "## [0.0.1]"
     */
    if (!md?.trim()) return [];
    const headerRe = /##\s+\[?(\d+\.\d+\.\d+)\]?(?:\(.*?\))?(?:\s*-\s*(?:(\d{4})\s*-\s*(\d{2})\s*-\s*(\d{2})|(\d{4}-\d{2}-\d{2})))?/g;

    const idx: number[] = [], vers: string[] = [], dates: string[] = [];
    let m: RegExpExecArray | null;
    while ((m = headerRe.exec(md))) {
        idx.push(m.index);
        vers.push(m[1] || "");
        dates.push(m[5] || (m[2] && m[3] && m[4] ? `${m[2]}-${m[3]}-${m[4]}` : ""));
    }
    if (!idx.length) return [];
    idx.push(md.length);

    return idx.slice(0, -1).map((start, i) => {
        const block = md.slice(start, idx[i + 1]);
        const features: string[] = [], bugFixes: string[] = [];
        block.split("\n").forEach((line) => {
            const t = line.trim();
            if (!t.startsWith("- ")) return;
            (t.includes("[Bugfix]") ? bugFixes : features).push(t.replace(/^- /, ""));
        });
        return {version: vers[i], date: dates[i], features, bugFixes};
    });
}

export function getLatestRelease(releases: Release[]): Release | null {
    /** Returns chronologically latest release (ISO-like date string). */
    if (!releases.length) return null;
    return releases.reduce((a, b) => (new Date(b.date) > new Date(a.date) ? b : a));
}

export async function fetchChangelog(url = "/CHANGELOG.md"): Promise<string> {
    /** Fetches the CHANGELOG file. */
    const r = await fetch(url);
    if (!r.ok) throw new Error(String(r.status));
    return r.text();
}
